import { getPhaseClasses, formatPhaseName, getPhaseDescription, type Phase } from '../../lib/workbook/utils';

interface PageHeaderProps {
  phase: Phase;
  title: string;
  pageNumber: number;
  className?: string;
}

export function PageHeader({ phase, title, pageNumber, className = '' }: PageHeaderProps) {
  const phaseClasses = getPhaseClasses(phase, 50);
  
  return (
    <div 
      className={`flex items-center justify-between px-6 py-3 border-b ${className}`}
      style={phaseClasses}
    >
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <div 
            className="w-6 h-6 rounded-full flex items-center justify-center text-white text-sm font-bold"
            style={{ backgroundColor: getPhaseClasses(phase, 600).color }}
          >
            {phase.charAt(0).toUpperCase()}
          </div>
          <div>
            <h1 className="text-lg font-bold" style={{ color: getPhaseClasses(phase, 600).color }}>
              {title}
            </h1>
            <p className="text-xs opacity-75">
              {formatPhaseName(phase)} • {getPhaseDescription(phase)}
            </p>
          </div>
        </div>
      </div>
      
      <div className="flex items-center gap-2">
        <div 
          className="px-2 py-1 rounded text-xs font-medium text-white"
          style={{ backgroundColor: getPhaseClasses(phase, 600).color }}
        >
          {formatPhaseName(phase)}
        </div>
        <span className="text-sm font-medium opacity-75">
          Page {pageNumber}
        </span>
      </div>
    </div>
  );
}






